import React from 'react';
import PropTypes from 'prop-types';
import IconCar from '@spothero/icons/car';
import IconClock from '@spothero/icons/clock';
import IconConcierge from '@spothero/icons/concierge';
import IconParking from '@spothero/icons/parking';
import IconShuttle from '@spothero/icons/shuttle';
import Label from '@spothero/ui/label';

const PLACEHOLDER = 'N/A';
const DEFAULT = 'default';
const TAXI = 'taxi';
const CURBSIDE_VALET = 'curbside-valet';
const ON_DEMAND = 'on-demand';
const PUBLIC_TRANSIT = 'public-transit';
const SHUTTLE_CONFIG = {
    [DEFAULT]: {
        rideType: 'Shuttle',
        serviceLabel: 'Shuttle Every',
        shuttleIcon: IconShuttle,
        displayDuration: true,
    },
    [TAXI]: {
        rideType: 'Taxi',
        shuttleIcon: IconCar,
        serviceDescription: 'Taxi',
        serviceLabel: 'Taxi/Rideshare',
        displayDuration: false,
    },
    [CURBSIDE_VALET]: {
        rideType: 'Concierge',
        serviceLabel: 'Concierge Service',
        serviceDescription: 'Curbside Dropoff',
        displayDuration: false,
    },
    [ON_DEMAND]: {
        serviceLabel: 'Shuttle',
        serviceDescription: 'On Demand',
        shuttleIcon: IconConcierge,
        displayDuration: true,
    },
    [PUBLIC_TRANSIT]: {
        rideType: 'Public Transit',
        serviceLabel: 'Park and Ride',
        serviceDescription: 'Public Transit Accessible',
        displayDuration: false,
    },
};

const ImportantInformation = ({
    data: {
        details: {code, spot_type: spotType} = {},
        shuttle: {
            duration,
            fast_frequency: shuttleMin,
            slow_frequency: shuttleMax,
            type: shuttleType,
        } = {},
    } = {},
}) => {
    const {
        displayDuration,
        rideType,
        serviceDescription,
        serviceLabel,
        shuttleIcon,
    } = {
        ...SHUTTLE_CONFIG[DEFAULT],
        ...SHUTTLE_CONFIG[shuttleType],
    };
    const shuttleSpan =
        shuttleMin && shuttleMax
            ? `${shuttleMin} - ${shuttleMax}`
            : shuttleMin || shuttleMax || '';
    const description =
        serviceDescription || (shuttleSpan && `${shuttleSpan} Min`);
    const Icon = shuttleIcon;

    return (
        <div className="ImportantInformation">
            <ul className="ImportantInformation-list">
                <li className="ImportantInformation-item">
                    <IconParking />
                    <div className="ImportantInformation-item-content">
                        <Label>Spot Type</Label>
                        <p>{spotType || PLACEHOLDER}</p>
                    </div>
                </li>
                <li className="ImportantInformation-item">
                    <IconClock />
                    <div className="ImportantInformation-item-content">
                        <Label>{serviceLabel}</Label>
                        <p>{description || PLACEHOLDER}</p>
                    </div>
                </li>
                {displayDuration && (
                    <li className="ImportantInformation-item">
                        <Icon />
                        <div className="ImportantInformation-item-content">
                            <Label>
                                {rideType} To {code}
                            </Label>
                            <p>{duration ? `${duration} Min` : PLACEHOLDER}</p>
                        </div>
                    </li>
                )}
            </ul>
        </div>
    );
};

ImportantInformation.propTypes = {
    data: PropTypes.object.isRequired,
};

export default ImportantInformation;
